import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

require('./PlannedMaintenanceSchedulesOverviewPage.less');

const PlannedMaintenanceSchedulesOverviewPage: FC<any> = ({
	history,
	userType,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/plannedMaintenance/overview/${key}`),
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'all',
			name: 'Schedules',
		},
		{
			key: 'templates/overview',
			name: 'Templates',
		},
	];

	return (
		<>
			<Route
				path={`/${userType}/plannedMaintenance/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/plannedMaintenance/overview/all`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Planned Maintenance"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="plannedMaintenanceSchedulesOverviewPage"
			/>
		</>
	);
};

const ComponentWithoutUserType = withRouter<any, any>(
	connect()(PlannedMaintenanceSchedulesOverviewPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
